// extracted by mini-css-extract-plugin
module.exports = {"root":"_27m_b"};